import { takeLatest } from 'redux-saga/effects';
import _ from 'lodash';

import { fetchRolesRoutine, saveRoleRoutine, removeRoleRoutine } from '../routines';

import { fetchColSaga, updateSaga, getTenantPath, setSaga } from './helper';

function* watchFetchRolesSaga() {
  yield takeLatest(fetchRolesRoutine.TRIGGER, fetchColSaga(fetchRolesRoutine, () => getTenantPath('/roles')));
}

function* watchSaveRoleSaga() {
  yield takeLatest(saveRoleRoutine.TRIGGER, setSaga(saveRoleRoutine, (role) => getTenantPath(`/roles/${role.id}`), (role) => role));
}

function* watchRemoveRoleSaga() {
  yield takeLatest(removeRoleRoutine.TRIGGER, updateSaga(removeRoleRoutine, (role) => getTenantPath(`/roles/${role.id}`), (role) => _.assign(role, { deleted: { at: new Date().toISOString() } })));
}

export {
  watchFetchRolesSaga,
  watchSaveRoleSaga,
  watchRemoveRoleSaga,
};



// WEBPACK FOOTER //
// ./src/sagas/roles.js